import { graphql } from '@newfront-insurance/graphql-frontend';

export const MARK_CHAT_AS_READ = graphql(`
  mutation MarkChatAsRead($chatUuid: String!) {
    markChatAsRead(chatUuid: $chatUuid) {
      uuid
      hasUnreadMessages
      activeStreamId
    }
  }
`);

export const GET_NOVA_SETTINGS = graphql(`
  query GetNovaSettings($userUuid: String!) {
    getNovaSettings(userUuid: $userUuid) {
      notificationsEnabled
      outlookConnectEnabled
      outlookConnectedEmailGroupIds
      outlookSharedInboxes
    }
  }
`);

export const UPDATE_NOVA_SETTINGS = graphql(`
  mutation UpdateNovaSettings(
    $userUuid: String!
    $notificationsEnabled: Boolean
    $outlookConnectEnabled: Boolean
    $outlookConnectedEmailGroupIds: [String!]
    $outlookSharedInboxes: [String!]
  ) {
    updateNovaSettings(
      userUuid: $userUuid
      notificationsEnabled: $notificationsEnabled
      outlookConnectEnabled: $outlookConnectEnabled
      outlookConnectedEmailGroupIds: $outlookConnectedEmailGroupIds
      outlookSharedInboxes: $outlookSharedInboxes
    ) {
      notificationsEnabled
      outlookConnectEnabled
      outlookConnectedEmailGroupIds
      outlookSharedInboxes
    }
  }
`);

export const START_NOVA_MICROSOFT_GRAPH_AUTHORIZATION = graphql(`
  mutation StartNovaMicrosoftGraphAuthorization($command: StartNovaMicrosoftGraphAuthorizationInput) {
    startNovaMicrosoftGraphAuthorization(command: $command) {
      authorizationUrl
      connectionUuid
      expiresAt
      state
    }
  }
`);

export const COMPLETE_NOVA_MICROSOFT_GRAPH_AUTHORIZATION = graphql(`
  mutation CompleteNovaMicrosoftGraphAuthorization($command: CompleteNovaMicrosoftGraphAuthorizationInput!) {
    completeNovaMicrosoftGraphAuthorization(command: $command) {
      connectionUuid
      status
    }
  }
`);

export const GET_NOVA_MICROSOFT_GRAPH_CONNECTION_STATUS = graphql(`
  query GetNovaMicrosoftGraphConnectionStatus {
    getNovaMicrosoftGraphConnectionStatus {
      connected
      connectionUuid
      externalUsername
      missingScopes
      needsReauth
      status
    }
  }
`);

export const ACQUIRE_NOVA_MICROSOFT_GRAPH_DELEGATED_TOKEN = graphql(`
  mutation AcquireNovaMicrosoftGraphDelegatedToken {
    acquireNovaMicrosoftGraphDelegatedToken {
      accessToken
      connectionUuid
      expiresAt
      missingScopes
      status
      tokenType
    }
  }
`);

export const DISCONNECT_NOVA_MICROSOFT_GRAPH_CONNECTION = graphql(`
  mutation DisconnectNovaMicrosoftGraphConnection {
    disconnectNovaMicrosoftGraphConnection {
      connected
      connectionUuid
      externalUsername
      missingScopes
      needsReauth
      status
    }
  }
`);

export const BUILD_CUSTOM_SKILL = graphql(`
  mutation BuildCustomSkill($command: BuildCustomSkillInput!) {
    buildCustomSkill(command: $command) {
      uuid
      source
      command
      enabled
      sourceFileUuid
      frontmatter {
        name
        description
        summary
        overview
        category
      }
      createdAt
      updatedAt
    }
  }
`);

export const CREATE_CUSTOM_SKILL = graphql(`
  mutation CreateCustomSkill($command: CreateCustomSkillInput!) {
    createCustomSkill(command: $command) {
      uuid
      source
      command
      enabled
      sourceFileUuid
      frontmatter {
        name
        description
        summary
        overview
        category
      }
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_CUSTOM_SKILL = graphql(`
  mutation UpdateCustomSkill($uuid: String!, $command: UpdateCustomSkillInput!) {
    updateCustomSkill: updateCustomSkill(uuid: $uuid, command: $command) {
      uuid
      source
      command
      enabled
      sourceFileUuid
      frontmatter {
        name
        description
        summary
        overview
        category
      }
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_CUSTOM_SKILL = graphql(`
  mutation DeleteCustomSkill($uuid: String!) {
    deleteCustomSkill: deleteCustomSkill(uuid: $uuid)
  }
`);
